import useFetchData from "./useFetchData";

export const useCurrency = () => {

    const requestOptions = {
        method: 'GET',  // Adjust the HTTP method as needed
        cacheFor: 24 * 60 * 60 * 1000, // ✅ 24 hours cache
    };

    requestOptions.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    const state = useFetchData("/configuration/currency-list/user/", requestOptions);
    // console.log(state?.data?.data);
    return {
        currency: state?.data?.data
    }
};

